import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { criarConversorProposta, type ConverterPropostaParams } from '../../../backend/src/services/propostas/converter-proposta';
export type { ConverterPropostaParams, ConverterPropostaResult } from '../../../backend/src/services/propostas/converter-proposta';
export const { invalidarCacheConversor, resolverPlano, criarItensAparelhoFaltantes, criarItensPassaportFaltantes, itensPassaportForaDaProposta, valorLinhaComAdicionais, resolverProdutoDaLinha, converterPropostaEmItens } = criarConversorProposta(supabase, toast);

/**
 * Hook para usar a conversão de proposta
 */
export function useConverterPropostaEmItens() {
  const converter = async (params: ConverterPropostaParams) => {
    console.log('[useConverterPropostaEmItens] Iniciando conversão:', {
      pedidoId: params.pedidoId,
      totalLinhas: params.composicao?.linhas?.length || 0,
    });

    const result = await converterPropostaEmItens(params);

    if (result.success) {
      console.log('[useConverterPropostaEmItens] Conversão concluída:', {
        itensCreados: result.itensCreados,
      });

      if (result.itensCreados > 0 && result.errors.length === 0) {
        toast.success(`${result.itensCreados} item(ns) criado(s) automaticamente`);
      } else if (result.itensCreados > 0 && result.errors.length > 0) {
        toast.warning(`${result.itensCreados} item(ns) criado(s), mas com ${result.errors.length} falha(s)`, {
          description: result.errors.slice(0, 2).join(' | '),
        });
      } else if (result.itensCreados === 0) {
        toast.error('Nenhum item foi criado', {
          description: result.errors.length > 0
            ? result.errors.slice(0, 2).join(' | ')
            : 'A proposta não gerou itens válidos. Verifique a configuração de produtos.',
        });
      }
    } else {
      console.error('[useConverterPropostaEmItens] Erros na conversão:', result.errors);
      toast.error('Erro ao criar itens do pedido', {
        description: result.errors[0] || 'Erro desconhecido',
      });
    }

    return result;
  };

  return { converter };
}
